import React, { createContext, useContext, useState, useEffect } from 'react';
import { getTenantBySubdomain } from '../services/firestoreService';

const TenantContext = createContext();

export const useTenant = () => {
    const context = useContext(TenantContext);
    if (!context) {
        throw new Error('useTenant must be used within a TenantProvider');
    }
    return context;
};

export const TenantProvider = ({ children }) => {
    const [tenant, setTenant] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // サブドメインを取得する関数
    const getSubdomain = () => {
        const hostname = window.location.hostname;
        const parts = hostname.split('.');

        // localhostの場合
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'default';
        }

        // suisui.lifeドメインの場合のみサブドメインとして扱う
        if (parts.length > 2 &&
            parts[parts.length - 2] === 'suisui' &&
            parts[parts.length - 1] === 'life') {
            return parts[0];
        }

        // メインドメインの場合
        return 'default';
    };

    useEffect(() => {
        const fetchTenant = async () => {
            try {
                setLoading(true);
                const subdomain = getSubdomain();

                // サブドメインがdefaultの場合はテナント情報を取得しない
                if (subdomain === 'default') {
                    setTenant(null);
                    setLoading(false);
                    return;
                }

                const tenantData = await getTenantBySubdomain(subdomain);
                setTenant(tenantData);

                if (!tenantData) {
                    setError('テナントが見つかりません');
                }
            } catch (err) {
                console.error('テナントの取得に失敗しました:', err);
                // エラーが発生してもアプリケーションは継続動作
                setTenant(null);
                setError(null);
            } finally {
                setLoading(false);
            }
        };

        fetchTenant();
    }, []);

    const value = {
        tenant,
        loading,
        error,
        subdomain: getSubdomain(),
    };

    return (
        <TenantContext.Provider value={value}>
            {children}
        </TenantContext.Provider>
    );
}; 